import { CenterTefl } from '../../../lib/types/models/center-tefl/center-tefl'
import { CenterTeflInput } from '../../../lib/types/models/center-tefl/center-tefl-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export async function assignCenterTefl(input: CenterTeflInput & { centerId: number }) {
  const { centerId, ...rest } = input

  return restApiClient
    .url(constructApiUrl(API.centers.assignCenterTefl.url, { id: centerId }))
    .post<CenterTefl>({ ...rest })
}
